import { fetchApplicationBuildId } from 'shared';
import { recordApplicationBuildId } from './globalActions';
export const getApplicationBuildId = () => {
    return async function (dispatch) {
        const applicationBuildId = await fetchApplicationBuildId();
        dispatch(recordApplicationBuildId(applicationBuildId));
    };
};
